import Layout from "@/layout";
export default {
  path: "Order",
  component: () => import('@/views/AppMain/index'),
  name: "Order",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "订单管理",
    keepAlive: false,
    icon: '1011',
    activeIcon: '1010',
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    // {
    //   hidden: false,
    //   path: "CustomerOrder",
    //   component: () => import('@/views/AppMain/index'),
    //   name: "CustomerOrder",
    //   alwaysShow: true,
    //   meta: {
    //     title: "客户订单",
    //     keepAlive: false,
    //   },
    //   children:[
    //     {
    //       hidden: false,
    //       path: "CustomerOrder1",
    //       component: () => import("@/views/HeadOfficeManagement/Order/CustomerOrder"),
    //       name: "CustomerOrder1",
    //       meta: {
    //         title: "收银订单",
    //         keepAlive: true,
    //       },
    //     },
    //     {
    //       hidden: false,
    //       path: "PickUpOrder",
    //       component: () => import("@/views/HeadOfficeManagement/Order/PickUpOrder"),
    //       name: "PickUpOrder",
    //       meta: {
    //         title: "自提订单",
    //         keepAlive: true,
    //       },
    //     },
    //     {
    //       hidden: false,
    //       path: "DeliveryOrder",
    //       component: () => import("@/views/HeadOfficeManagement/Order/DeliveryOrder"),
    //       name: "DeliveryOrder",
    //       meta: {
    //         title: "配送订单",
    //         keepAlive: true,
    //       },
    //     },
        // {
        //   hidden: false,
        //   path: "ReturnFefund",
        //   component: () => import("@/views/HeadOfficeManagement/Order/ReturnFefund"),
        //   name: "ReturnFefund",
        //   meta: {
        //     title: "退货退款",
        //     keepAlive: true,
        //   },
        // },
        // {
        //   hidden: true,
        //   path: "CustomerOrderDetail",
        //   component: () => import("@/views/HeadOfficeManagement/Order/CustomerOrderDetail"),
        //   name: "CustomerOrderDetail",
        //   meta: {
        //     title: "收银订单详情",
        //     keepAlive: false,
        //     activeMenu: '/HeadOfficeManagement/Order/CustomerOrder/CustomerOrder1'
        //   },
        // },
    //     {
    //       hidden: true,
    //       path: "PickUpOrderDetail",
    //       component: () => import("@/views/HeadOfficeManagement/Order/PickUpOrderDetail"),
    //       name: "PickUpOrderDetail",
    //       meta: {
    //         title: "自提订单详情",
    //         keepAlive: false,
    //         activeMenu: '/HeadOfficeManagement/Order/CustomerOrder/PickUpOrder'
    //       },
    //     },
    //     {
    //       hidden: true,
    //       path: "DeliveryOrderDetail",
    //       component: () => import("@/views/HeadOfficeManagement/Order/DeliveryOrderDetail"),
    //       name: "DeliveryOrderDetail",
    //       meta: {
    //         title: "配送订单详情",
    //         keepAlive: false,
    //         activeMenu: '/HeadOfficeManagement/Order/CustomerOrder/DeliveryOrder'
    //       },
    //     },
    //     {
    //       hidden: true,
    //       path: "ReturnFefundDetail",
    //       component: () => import("@/views/HeadOfficeManagement/Order/ReturnFefundDetail"),
    //       name: "ReturnFefundDetail",
    //       meta: {
    //         title: "退货退款订单详情",
    //         keepAlive: false,
    //         activeMenu: '/HeadOfficeManagement/Order/CustomerOrder/ReturnFefund'
    //       },
    //     },
    //   ]
    // },
    {
        hidden: false,
        path: "CustomerOrder",
        component: () => import("@/views/HeadOfficeManagement/Order/CustomerOrder"),
        name: "CustomerOrder",
        meta: {
          title: "客户订单",
          keepAlive: true,
        },
      },
      {
        hidden: false,
        path: "ReturnFefund",
        component: () => import("@/views/HeadOfficeManagement/Order/ReturnFefund"),
        name: "ReturnFefund",
        meta: {
          title: "退货退款",
          keepAlive: true,
        },
      },
      {
        hidden: true,
        path: "ReturnFefundDetail",
        component: () => import("@/views/HeadOfficeManagement/Order/ReturnFefundDetail"),
        name: "ReturnFefundDetail",
        meta: {
          title: "退货退款详情",
          keepAlive: true,
          activeMenu: '/HeadOfficeManagement/Order/ReturnFefund'
        },
      },
      {
          hidden: true,
          path: "CustomerOrderDetail",
          component: () => import("@/views/HeadOfficeManagement/Order/CustomerOrderDetail"),
          name: "CustomerOrderDetail",
          meta: {
            title: "客户订单详情",
            keepAlive: false,
            activeMenu: '/HeadOfficeManagement/Order/CustomerOrder'
          },
        },
      {
        hidden: true,
        path: "PurchaseOrderDetail",
        component: () => import("@/views/HeadOfficeManagement/Order/PurchaseOrderDetail"),
        name: "PurchaseOrderDetail",
        meta: {
          title: "采购单详情",
          keepAlive: false,
          activeMenu: '/HeadOfficeManagement/Order/PurchaseOrder'
        },
      },
      {
        hidden: true,
        path: "ConfirmShipment",
        component: () => import("@/views/HeadOfficeManagement/Order/ConfirmShipment"),
        name: "ConfirmShipment",
        meta: {
          title: "确认发货",
          keepAlive: false,
          activeMenu: '/HeadOfficeManagement/Order/PurchaseOrder'
        },
      },
      // {
      //   hidden: true,
      //   path: "CustomerOrderDetail",
      //   component: () => import("@/views/HeadOfficeManagement/Order/CustomerOrderDetail"),
      //   name: "CustomerOrderDetail",
      //   meta: {
      //     title: "订单详情",
      //     keepAlive: false,
      //     activeMenu: '/HeadOfficeManagement/Order/ReturnFefund'
      //   },
      // },
  ]
};
